import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';
import LiveSearchResultsGridViewDataProvider from '../dataProvider/LiveSearchResultsGridViewDataProvider';

export class LiveSearchResultsGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();

    this.map.set(API_TYPE_GZ, LiveSearchResultsGridViewDataProvider);
  }
}
